import service from "../service";
// import { getApiBaseUrl } from "../config";

export default {
    async getYoutubeList() {
        const response = await service.get(`/api/video/get_all_video`);
        return response;
    },

    async addYoutube(youtube) {
        const response = await service.post(
            `/api/video/add_video_list`,
            youtube
        );
        return response;
    },

    async deleteYoutube(youtube_id) {
        const response = await service.delete(
            `/api/video/delete/${youtube_id}`
        );
        return response;
    },
};
